export enum RateFormKeys {
    rateId = 'rateId',
    keepOldPrice = 'keepOldPrice',
}

export interface RateFormValues {
    [RateFormKeys.rateId]: string;
    [RateFormKeys.keepOldPrice]: boolean;
}
